import { render, staticRenderFns } from "./GeneralScaffold.vue?vue&type=template&id=01ee0a0b&"
import script from "./GeneralScaffold.vue?vue&type=script&lang=ts&"
export * from "./GeneralScaffold.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports